export interface Video {
  id: string;
  user_id: string;
  video_url: string;
  video_platform: 'youtube' | 'vimeo' | 'facebook' | 'tiktok' | 'instagram' | 'twitch' | 'dailymotion';
  video_id: string;
  title: string;
  description?: string;
  thumbnail_url?: string;
  duration?: number;
  
  // Song metadata
  song_id?: string;
  song_name?: string;
  artist_name?: string;
  album_name?: string;
  spotify_track_id?: string;
  
  // Optional sequence link
  sequence_id?: string;
  
  // Display metadata
  display_id?: string;
  display_year?: number;
  holiday?: string;
  
  // Engagement metrics
  view_count: number;
  like_count: number;
  
  // Timestamps
  created_at: string;
  updated_at: string;
  
  // User interaction status (added by queries)
  is_liked?: boolean;
  
  // Related data (when joined)
  user?: {
    id: string;
    username?: string;
    email: string;
  };
  sequence?: {
    id: string;
    title: string;
    price: number | null;
    is_free: boolean;
    // Spotify metadata
    spotify_preview_url?: string;
    spotify_duration_ms?: number;
    spotify_popularity?: number;
    spotify_explicit?: boolean;
    album_cover_url?: string;
  };
  display?: {
    id: number;
    name: string;
    latitude?: number | null;
    longitude?: number | null;
    city?: string | null;
    state?: string | null;
    location?: string | null;
    has_real_coordinates?: boolean;
  };
}

export interface VideoListParams {
  page?: number;
  limit?: number;
  holiday?: string;
  display_year?: number;
  has_sequence?: boolean;
  search?: string;
  sort_by?: 'recent' | 'popular' | 'most_liked';
}

export interface VideoListResponse {
  videos: Video[];
  total: number;
  page: number;
  total_pages: number;
  has_next: boolean;
  has_prev: boolean;
}

export interface CreateVideoRequest {
  video_url: string;
  title?: string;
  description?: string;
  song_name?: string;
  artist_name?: string;
  album_name?: string;
  spotify_track_id?: string;
  sequence_id?: string;
  display_id?: string;
  display_year?: number;
  holiday?: string;
}

export interface VideoLikeResponse {
  is_liked: boolean;
  like_count: number;
}

export interface VideoWithRelated {
  video: Video;
  related_videos: Video[];
}

export const HOLIDAY_OPTIONS = [
  { value: 'Christmas', label: 'Christmas' },
  { value: 'Halloween', label: 'Halloween' },
  { value: 'FourthOfJuly', label: 'Fourth of July' },
  { value: 'Easter', label: 'Easter' },
  { value: 'Thanksgiving', label: 'Thanksgiving' },
  { value: 'NewYear', label: 'New Year' },
  { value: 'Other', label: 'Other' }
] as const;

export const SORT_OPTIONS = [
  { value: 'recent', label: 'Most Recent' },
  { value: 'popular', label: 'Most Viewed' },
  { value: 'most_liked', label: 'Most Liked' }
] as const;